<!-- 发票 -->
<template>
  <div class="body">
    <van-nav-bar
      title="燃气开票"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="center">
      <div class="gas-account-div">
        <van-field
          v-model="gasAccount"
          center
          clearable
          label="燃气户号"
          placeholder="请输入燃气户号"
        >
          <template #button>
            <van-button size="small" type="primary" class="query-button" @click="checkUserGas()">查询</van-button>
          </template>
        </van-field>
      </div>
      <div v-if="isShowRecord" class="year-box">
        <van-cell :label="addMy" >
          <template #title>
              <span @click="isShowYear = true">{{selectYear}}</span>
          </template>
          <template #right-icon>
            <div class="van-right">
              <span>全选</span>
              <van-checkbox v-model="checked" checked-color="#ee0a24" @click="onCheck" />
            </div>
          </template>
        </van-cell>
      </div>
      <div class="group">
        <van-cell-group v-if="fillArr.length !== 0">
          <van-cell :title="item.payDT" v-for="(item, index) in fillArr" :key="index">
            <template #right-icon>
              <div class="van-right">
                <span>{{item.payAmt}}元</span>
                <van-checkbox v-model="item.isChecked" checked-color="#ee0a24" @click="onChildCheck(item)" />
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        <div v-else class="no-data">暂无数据</div>
      </div>
      <van-button type="danger" v-if="isShowRecord" class="btm-btn" @click="next">下一步</van-button>
    </div>
    <van-action-sheet v-model="isShowYear" :actions="yearActions" @select="onSelect" close-on-click-action />
  </div>
</template>

<script>
import { queryBilling } from '../../api/bill'
import { getBjtongAccessToken, checkUserGas, operationRecords } from '../../api/accountInformation'
import { passwordEncryption } from '../../utils/jsencrypt'
import { getToken } from '../../api/login'

export default {
  data () {
    return {
      selectYear: '',
      addMy: '',
      checked: false,
      fillArrAdd: [],
      fillArr: [],
      isShowYear: false,
      yearActions: [],
      checkArr: [],
      obj: {},
      code: '', // 统一认证平台返回的code
      telephone: '', // 登录时的用户名
      password: '', // 登录密码
      gasAccount: '', // 燃气户号-查询条件
      isShowRecord: false, // 是否展示缴费记录和“下一步”按钮
      gasAccountInfo: {} // 户号信息
    }
  },
  created () {
    /*this.onCheck()
    this.getData()*/
  },
  mounted () {
    this.code = this.$route.query.code
    console.log('统一认证平台返回的code为', this.code)
    this.state = this.$route.query.state
    if (this.state == 'PC') {
      window.location.href = 'https://zt.bjgas.com/resource/PC_AppH5_sit/#/pcGasInvoice?code=' + this.code
    } else {
      this.getBjtongAccessToken(this.code)
    }
  },
  watch: {
    checkArr (newVal, oldVal) {
      const that = this
      let add = 0
      newVal.forEach(item => {
        if (that.selectYear === '全部') {
          add = add + Number(item.payAmt)
        } else {
          const a = item.payDT.substring(0, 4)
          // eslint-disable-next-line eqeqeq
          if (a == that.selectYear) {
            add = add + Number(item.payAmt)
          }
        }
      })
      this.addMy = '小计：¥' + add.toFixed(2) + '  ' + newVal.length + '个缴费记录'
    }
  },
  methods: {
    getData () {
      const that = this
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const date = new Date()
      that.selectYear = date.getFullYear()
      // this.obj = this.$store.state.cardObj
      // {"CM-FPAMT-QUERY":{"acctId":"燃气号","cardType":"燃气户号类型","isRead":"是否读卡"}}
      const params = {
        'CM-FPAMT-QUERY': {
          acctId: that.gasAccountInfo.gasAccount,
          cardType: that.gasAccountInfo.meterType
        }
      }
      queryBilling(JSON.stringify(params)).then(res => {
        that.fillArrAdd = res.data['soapenv:Envelope']['soapenv:Body']['CM-FPAMT-QUERY'].results ? res.data['soapenv:Envelope']['soapenv:Body']['CM-FPAMT-QUERY'].results : []
        that.fillArr = []
        that.fillArrAdd.forEach(item => {
          const a = item.payDT.substring(0, 4)
          // eslint-disable-next-line eqeqeq
          if (a == that.selectYear) {
            that.fillArr.push(item)
          }
        })
        // 年份选择框数据
        const y = String(that.selectYear)
        const y1 = String(that.selectYear - 1)
        const y2 = String(that.selectYear - 2)
        const arr = [
          { name: y },
          { name: y1 },
          { name: y2 },
          { name: '全部' }
        ]
        that.yearActions = arr
        that.isShowRecord = true
        that.$toast.clear()
      }).catch(() => {
        that.$toast.fail('开票记录查询失败')
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    // 下拉框年份选择
    onSelect (action) {
      this.selectYear = action.name
      this.fillArr = []
      if (action.name === '全部') {
        this.fillArr = [...this.fillArrAdd]
      } else {
        this.fillArrAdd.forEach(item => {
          const a = item.payDT.substring(0, 4)
          // eslint-disable-next-line eqeqeq
          if (a == action.name) {
            this.fillArr.push(item)
          }
        })
      }
      this.onCheck()
    },
    // 全选单选框
    onCheck () {
      // this.$set (this.selectedarr, index, option)
      if (this.checked) {
        this.checkArr = []
        this.fillArr.forEach(item => {
          item.isChecked = true
          this.checkArr.push(item)
        })
      } else {
        this.fillArr.forEach(item => {
          item.isChecked = false
        })
        this.checkArr = []
      }
      this.$forceUpdate()
    },
    // 缴费记录单选框
    onChildCheck (val) {
      let flag = 0
      this.fillArr.forEach(item => {
        if (item.isChecked === false) {
          flag = 1
        }
      })
      if (flag === 0) {
        this.checked = true
      }
      if (val.isChecked) {
        this.checkArr.push(val)
      } else {
        const a = this.checkArr.indexOf(val)
        if (a !== -1) {
          this.checkArr.splice(a, 1)
        }
        this.checked = false
      }
      this.$forceUpdate()
    },
    // 下一步
    next () {
      const that = this
      if (that.checkArr.length === 0) {
        that.$toast.fail('请选择数据')
      } else {
        that.$router.push({
          name: 'BillDetails',
          params: {
            arr: that.checkArr,
            gasAccountInfo: that.gasAccountInfo
          }
        })
      }
    },

    // 获取登录人的信息，根据账号密码获得北燃的token
    getBjtongAccessToken (code) {
      const that = this
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        grantCode: code,
        operationType: '开发票'
      }
      getBjtongAccessToken(params).then(res => {
        if (res.data.success) {
          that.telephone = res.data.rows[0].userName;
          that.password = res.data.rows[0].passwordEncrypted;
          window.localStorage.userId = res.data.rows[0].id;
          window.localStorage.userInfo = JSON.stringify(res.data.rows[0]);
          that.toAccountNumberManagement();
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    },

    // 登录
    toAccountNumberManagement () {
      const that = this
      const params = {
        client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
        client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
        grant_type: 'password',
        // username: passwordEncryption(that.telephone),
        username: that.telephone,
        // password: passwordEncryption(that.password)
        // password: passwordEncryption('Bjtong')
        password: 'Bjtong'
      }
      getToken(params).then(res => {
        that.onLogin(res.data)
      }).catch(() => {
        this.$toast.fail('用户名或密码错误')
      })
    },

    // 获取token成功
    onLogin (resp) {
      window.localStorage.smartHistory = ''
      if (resp.access_token) {
        window.localStorage.tokenType = resp.token_type
        window.localStorage.token = resp.access_token
        this.$toast.clear();
      } else {
        this.$toast.fail('获取token失败')
      }
    },

    // 校验户号并绑定
    checkUserGas () {
      const that = this
      if (that.gasAccount === '') {
        that.$toast.fail('请输入燃气户号')
        return
      }
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        userId: window.localStorage.userId,
        gasAccount: that.gasAccount
      }
      checkUserGas(params).then(res => {
        if (res.data.success) {
          if (res.data.rows[0].meterType == 'R') {
            that.gasAccountInfo = res.data.rows[0]
            that.onCheck()
            that.getData()
          } else {
            that.fillArr = []
            that.fillArrAdd = []
            that.checkArr = []
            that.isShowRecord = false
            that.$toast.fail('开票只支持普表')
          }
          that.operationRecords()
        } else {
          that.fillArr = []
          that.fillArrAdd = []
          that.checkArr = []
          that.isShowRecord = false
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    },

    // 记录用户操作类型
    operationRecords () {
      const that = this
      const params = {
        userId: window.localStorage.userId,
        gasAccount: that.gasAccount,
        operationType: '开发票'
      }
      operationRecords(params).then(res => {
        if (res.data.success) {
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
}
.center {
  height: calc(100% - 45px);
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.center >>> .van-cell {
  height: 100%;
  padding: 0;
  color: #27282E;
}
.center >>> .van-cell__title{
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  font-size: 16px;
}
.center >>> .van-loading--vertical {
  margin-top: 100px;
}
.van-right {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  align-items: center;
  width: auto;
}
.van-right span {
  margin-right: 10px;
}
.year-box {
  width: 100%;
  height: 90px;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 0px 0px 9px rgba(7, 15, 86, 0.1);
  border-radius: 8px;
  padding: 0 20px;
  box-sizing: border-box;
}
.year-box >>> .van-cell__label {
  color: #62667A;
  font-size: 16px;
}
.center .group {
  height: calc(100% - 210px);
  overflow: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.group >>> .van-cell {
  height: 50px;
}
.group span {
  color: #62667A;
}
.btm-btn {
  background: #CE0022;
  box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  opacity: 1;
  border-radius: 8px;
  width: 100%;
  height: 50px;
}
.no-data {
  width: 100%;
  margin-top: 30%;
  text-align: center;
  color: #62667A;
  font-size: 24px;
}

.query-button {
  background-color: #CE0022;
  border-color: #CE0022;
}

.gas-account-div {
  margin-bottom: 10px;
}
</style>
